/**
 * CategoriesCarousel.tsx — Renders a horizontal scrolling carousel of category cards.
 *
 * JSON trigger: `uiCompType.method: "renderCategoriesCarousel"`
 * Data field:   `sectionData.items` — Array of category `SectionData` objects.
 *
 * **Data preparation:**
 * Items are transformed by `prepareCardsForCategoriesGrid` (from `@/translator`)
 * into a standardised card shape before being passed to `CustCarousel`.
 *
 * **Delegates to:** `CustCarousel` (wraps `CommonCarouselComponent`).
 *
 * **Style slots:** `uiCompType.styles` (container), `uiCompType.options.height`,
 * `uiCompType.options.width` forwarded to each card.
 */
import React from "react";
import { Grid } from "@mui/material";
import cssStyles from "./cms_renderer.module.scss";
import { prepareCardsForCategoriesGrid } from '@/translator';
import CustCarousel  from "./CustCarousel";
import GenerateCategoryCard from "@/app/components/products/category_cards";
import type { SectionData, ComponentRenderProps } from "./index";
import { getBrandPathEntry } from "./cmsUtils";
import { handleProductSelection } from "./shared";

interface CategoriesCarouselProps {
    sectionData: SectionData;
    props: ComponentRenderProps;
}

const CategoriesCarousel = ({ sectionData, props }: CategoriesCarouselProps): JSX.Element | null => {
    //console.log("CategoriesCarousel - sectionData:", sectionData);
    const { vendorName } = props;
    const items = GenerateCategoryCard(
        prepareCardsForCategoriesGrid(sectionData.items as any[], getBrandPathEntry(vendorName as string), vendorName as string),
        handleProductSelection,
        (sectionData.uiCompType?.options?.height || "320"),
        (sectionData.uiCompType?.options?.width || "320"),
        sectionData.trackId || "CategoryCarouselCards",
    );
    return <CustCarousel sectionData={{ ...sectionData, items }} props={props} />;
}
export default CategoriesCarousel;
